export default __webpack_public_path__ + "static/media/banner-bg-cashback-25mil.b7b65353.png";